import { useContext, useCallback } from 'react';
import { ImQrcode } from 'react-icons/im';

import PropTypes from 'prop-types';

import { AuthContext } from '../../../../../actions/auth-context';
import { getPdfClientOrder } from '../../../../../actions/order.service';

const GeneratePDFClientButton = ({ order }) => {
  const { hasPermissions } = useContext(AuthContext);

  const generatePdfClientFile = useCallback(async () => {
    const response = await getPdfClientOrder(order.id);

    window.open(response);
  }, [order]);

  return (
    <>
      {hasPermissions(['add_order', 'add_order']) && (
        <div className="col-sm col-md-4 col-lg-2 mt-2">
          <button
            className="btn btn-outline-primary btn-block col-12"
            type="button"
            onClick={generatePdfClientFile}
          >
            qr code <ImQrcode size={20} className="mb-1" />
          </button>
        </div>
      )}
    </>
  );
};

GeneratePDFClientButton.propTypes = {
  order: PropTypes.shape({
    id: PropTypes.string,
    order_status: PropTypes.string,
    is_rework: PropTypes.bool,
    products: PropTypes.arrayOf(Object),
    spcfiles: PropTypes.arrayOf(Object),
    person_id: PropTypes.string,
  }).isRequired,
};

export default GeneratePDFClientButton;
